/*
 * ---------------------------------------------------------------------------
 * PRIVATE SALE — GATE DE LA PDP
 * Cliente: NIIHAI · Black Comet
 * ---------------------------------------------------------------------------
 * Decide si en la ficha de producto se ve el precio de la private sale o el
 * precio normal.
 *
 * El criterio es haber pasado el overlay de la landing: el visitante entro con
 * el enlace del email (?ls=swim-access) o metio una contrasena valida. En
 * cualquiera de los dos casos `password-overlay-prysm` deja en localStorage la
 * clave `prysm_password_overlay_unlocked` con valor 'true'.
 *
 * OJO, para quien lea esto mas adelante: esto NO comprueba que el visitante
 * este suscrito a la newsletter. Eso no es comprobable desde el tema (Liquid
 * solo conoce clientes con sesion iniciada, no suscriptores de Klaviyo). Lo
 * que se comprueba es acceso legitimo a la landing, que en la practica es lo
 * mismo porque la landing esta cerrada con contrasena.
 *
 * El precio ya viene calculado desde Liquid; aqui solo se muestra u oculta.
 *
 * Asset externo a proposito: la app de optimizacion de la tienda (pcjs)
 * elimina los <script> inline de la pagina de producto.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'prysm_password_overlay_unlocked';

  function hasAccess() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === 'true';
    } catch (e) {
      // Safari en modo privado puede bloquear el acceso: sin acceso, precio normal.
      return false;
    }
  }

  function apply() {
    var privateBlocks = document.querySelectorAll('[data-ps-pdp]');
    if (!privateBlocks.length) return;

    var regularBlocks = document.querySelectorAll('[data-ps-pdp-regular]');
    var granted = hasAccess();
    var i;

    for (i = 0; i < privateBlocks.length; i++) {
      privateBlocks[i].hidden = !granted;
    }

    for (i = 0; i < regularBlocks.length; i++) {
      regularBlocks[i].hidden = granted;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  // El editor de temas recarga secciones enteras.
  document.addEventListener('shopify:section:load', apply);

  // Al cambiar de talla, <product-rerender> pide el bloque otra vez al servidor
  // y lo reemplaza: el HTML vuelve oculto y hay que volver a aplicar el gate.
  if (window.MutationObserver) {
    var target = document.querySelector('product-rerender') ||
                 document.querySelector('.product-info') ||
                 document.body;
    var pending = null;

    var observer = new MutationObserver(function () {
      // Debounce: un reemplazo dispara muchas mutaciones seguidas.
      if (pending) window.clearTimeout(pending);
      pending = window.setTimeout(apply, 50);
    });

    // Solo childList: cambiar la propiedad `hidden` no anade ni quita nodos,
    // asi que apply() no se autodispara.
    observer.observe(target, { childList: true, subtree: true });
  }
})();